import type { TNavEntryView } from '../components/types'
import {
    NAV_ENTRIES,
    type TNavDropdown,
    type TNavLink,
    type TTranslationKey,
} from '../constants/navigation'

type TLabelled = { labelKey: TTranslationKey; label: string }

export type TNavResolve = {
    label: (source: TLabelled) => string
    description: (link: TNavLink) => string | undefined
    linkClick?: (link: TNavLink) => (() => void) | undefined
    sectionClick?: (dropdown: TNavDropdown) => (() => void) | undefined
}

export const mapNavEntries = (resolve: TNavResolve): TNavEntryView[] =>
    NAV_ENTRIES.map(entry =>
        entry.kind === 'dropdown'
            ? {
                  kind: 'dropdown',
                  navKey: entry.navKey,
                  label: resolve.label(entry.dropdown),
                  items: entry.dropdown.links.map(link => ({
                      label: resolve.label(link),
                      href: link.href,
                      Icon: link.Icon,
                      description: resolve.description(link),
                      isNew: link.isNew,
                      onClick: resolve.linkClick?.(link),
                  })),
                  panel: entry.dropdown.panel,
                  collapsible: entry.collapsible,
                  onClick: resolve.sectionClick?.(entry.dropdown),
              }
            : {
                  kind: 'link',
                  navKey: entry.navKey,
                  label: resolve.label(entry.link),
                  href: entry.link.href,
                  isBrand: entry.isBrand,
                  collapsible: entry.collapsible,
                  onClick: resolve.linkClick?.(entry.link),
              },
    )
